import { default as _91slug_93lUEjW0WiIDMeta } from "/home/forge/career.proxify.io/releases/20261105110027/pages/[slug].vue?macro=true";
import { default as accessibility_45statementeIi7pU756uMeta } from "/home/forge/career.proxify.io/releases/20261105110027/pages/accessibility-statement.vue?macro=true";
import { default as _91slug_93z8o9fsiCisMeta } from "/home/forge/career.proxify.io/releases/20261105110027/pages/article/[slug].vue?macro=true";
import { default as cookie_45policyhGk5GqLNt2Meta } from "/home/forge/career.proxify.io/releases/20261105110027/pages/cookie-policy.vue?macro=true";
import { default as _91slug_93XQc3DrSFEpMeta } from "/home/forge/career.proxify.io/releases/20261105110027/pages/events/[slug].vue?macro=true";
import { default as indexHqqV9c70SEMeta } from "/home/forge/career.proxify.io/releases/20261105110027/pages/events/index.vue?macro=true";
import { default as how_45it_45worksoCbVjrhY4eMeta } from "/home/forge/career.proxify.io/releases/20261105110027/pages/how-it-works.vue?macro=true";
import { default as index0mxiCoGbXpMeta } from "/home/forge/career.proxify.io/releases/20261105110027/pages/index.vue?macro=true";
import { default as jobsLiH7cm2MJxMeta } from "/home/forge/career.proxify.io/releases/20261105110027/pages/jobs.vue?macro=true";
import { default as journalqyGDHeWCQ8Meta } from "/home/forge/career.proxify.io/releases/20261105110027/pages/journal.vue?macro=true";
import { default as privacy9izuyKd6UTMeta } from "/home/forge/career.proxify.io/releases/20261105110027/pages/privacy.vue?macro=true";
import { default as _91slug_93tDGnhMGnDiMeta } from "/home/forge/career.proxify.io/releases/20261105110027/pages/stories/[slug].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug()",
    component: () => import("/home/forge/career.proxify.io/releases/20261105110027/pages/[slug].vue")
  },
  {
    name: "accessibility-statement",
    path: "/accessibility-statement",
    component: () => import("/home/forge/career.proxify.io/releases/20261105110027/pages/accessibility-statement.vue")
  },
  {
    name: "article-slug",
    path: "/article/:slug()",
    component: () => import("/home/forge/career.proxify.io/releases/20261105110027/pages/article/[slug].vue")
  },
  {
    name: "cookie-policy",
    path: "/cookie-policy",
    component: () => import("/home/forge/career.proxify.io/releases/20261105110027/pages/cookie-policy.vue")
  },
  {
    name: "events-slug",
    path: "/events/:slug()",
    component: () => import("/home/forge/career.proxify.io/releases/20261105110027/pages/events/[slug].vue")
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/home/forge/career.proxify.io/releases/20261105110027/pages/events/index.vue")
  },
  {
    name: "how-it-works",
    path: "/how-it-works",
    component: () => import("/home/forge/career.proxify.io/releases/20261105110027/pages/how-it-works.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/forge/career.proxify.io/releases/20261105110027/pages/index.vue")
  },
  {
    name: "jobs",
    path: "/jobs",
    component: () => import("/home/forge/career.proxify.io/releases/20261105110027/pages/jobs.vue")
  },
  {
    name: "journal",
    path: "/journal",
    component: () => import("/home/forge/career.proxify.io/releases/20261105110027/pages/journal.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/home/forge/career.proxify.io/releases/20261105110027/pages/privacy.vue")
  },
  {
    name: "stories-slug",
    path: "/stories/:slug()",
    component: () => import("/home/forge/career.proxify.io/releases/20261105110027/pages/stories/[slug].vue")
  }
]